import { put, call, takeLatest } from 'redux-saga/effects';
import {
  ASSET_LIST_SUCCESSED,
  ASSET_LIST_FAILED,
  ASSET_LIST_REQUESTED,

  IMPORT_ASSET_LOGS_SUCCESSED,
  IMPORT_ASSET_LOGS_FAILED,
  IMPORT_ASSET_LOGS_REQUESTED,

  ASSET_DETAILS_REQUESTED,
  ASSET_DETAILS_SUCCESSED,
  ASSET_DETAILS_FAILED,
  ASSET_CREATE_REQUESTED,
  ASSET_CREATE_SUCCESSED,
  ASSET_CREATE_FAILED,
  ASSET_EDIT_REQUESTED,
  ASSET_EDIT_SUCCESSED,
  ASSET_EDIT_FAILED,
  ASSET_DELETE_REQUESTED,
  ASSET_DELETE_SUCCESSED,
  ASSET_DELETE_FAILED,
  IMPORT_ASSET_REQUESTED,
  IMPORT_ASSET_SUCCESSED,
  IMPORT_ASSET_FAILED,
  ASSET_CLASSIFICATION_LIST_SUCCESSED,
  ASSET_CLASSIFICATION_LIST_FAILED,
  ASSET_CLASSIFICATION_LIST_REQUESTED,
  ASSET_CONFIDENTIALITY_LIST_SUCCESSED,
  ASSET_CONFIDENTIALITY_LIST_FAILED,
  ASSET_CONFIDENTIALITY_LIST_REQUESTED,
  ASSET_AVAILABILITY_LIST_SUCCESSED,
  ASSET_AVAILABILITY_LIST_FAILED,
  ASSET_AVAILABILITY_LIST_REQUESTED,
  ASSET_INTEGRITY_LIST_SUCCESSED,
  ASSET_INTEGRITY_LIST_FAILED,
  ASSET_INTEGRITY_LIST_REQUESTED,
  ASSET_OS_LIST_SUCCESSED,
  ASSET_OS_LIST_FAILED,
  ASSET_OS_LIST_REQUESTED,
  ASSET_TYPE_BY_ID_SUCCESSED,
  ASSET_TYPE_BY_ID_FAILED,
  ASSET_TYPE_BY_ID_REQUESTED,
  ASSET_TYPES_LIST_SUCCESSED,
  ASSET_TYPES_LIST_FAILED,
  ASSET_TYPES_LIST_REQUESTED,
  ASSET_DASHBOARD_REQUESTED,
  ASSET_DASHBOARD_SUCCESSED,
  ASSET_DASHBOARD_FAILED,
  ASSET_CATEGORIES_LIST_SUCCESSED,
  ASSET_CATEGORIES_LIST_FAILED,
  ASSET_CATEGORIES_LIST_REQUESTED,
  ASSET_ENABLE_FIELDS_LIST_SUCCESSED,
  ASSET_ENABLE_FIELDS_LIST_FAILED,
  ASSET_ENABLE_FIELDS_LIST_REQUESTED,

  ASSET_CATEGORY_FIELDS_REQUESTED,
  ASSET_CATEGORY_FIELDS_SUCCESSED,
  ASSET_CATEGORY_FIELDS_FAILED,

  ASSET_TEMPLATE_LIST_REQUESTED,
  ASSET_TEMPLATE_LIST_SUCCESSED,
  ASSET_TEMPLATE_LIST_FAILED,

  ASSET_TEMPLATE_CREATE_REQUESTED,
  ASSET_TEMPLATE_CREATE_SUCCESSED,
  ASSET_TEMPLATE_CREATE_FAILED,

  ASSET_TEMPLATE_DRAFT_REQUESTED,
  ASSET_TEMPLATE_DRAFT_SUCCESSED,
  ASSET_TEMPLATE_DRAFT_FAILED,

  ASSET_IMPORT_PROCESS_REQUESTED,
  ASSET_IMPORT_PROCESS_SUCCESSED,
  ASSET_IMPORT_PROCESS_FAILED,

  ASSET_BULK_DELETE_REQUESTED,
  ASSET_BULK_DELETE_SUCCESSED,
  ASSET_BULK_DELETE_FAILED,

  ASSET_IMPORTED_JOB_DELETE_REQUESTED,
  ASSET_IMPORTED_JOB_DELETE_SUCCESSED,
  ASSET_IMPORTED_JOB_DELETE_FAILED,

  EXPORT_ASSET_LOGS_SUCCESSED,
  EXPORT_ASSET_LOGS_FAILED,
  EXPORT_ASSET_LOGS_REQUESTED,
  
  ASSET_EXPORT_JOB_DELETE_SUCCESSED,
  ASSET_EXPORT_JOB_DELETE_FAILED,
  ASSET_EXPORT_JOB_DELETE_REQUESTED
} from '../../constants/actionTypes';
import {
  listSaga,
  getSingleSaga,
  createSaga,
  editSaga,
  deleteSaga,
  importSaga,
  listAssetClassificationSaga,
  listAssetConfidentialitySaga,
  listAssetAvailabilitySaga,
  listAssetIntegritySaga,
  listAssetOSSaga,
  getAssetDashboardSaga,
  getAssetTypeById,
  listAssetCategoriesSaga,
  listAssetEnableFieldsSaga,
  listAssetTypesSaga,
  listGetAssetFieldsSaga,
  getAssetTemplates,
  createTemplateSaga,
  assetTemplateDraftSaga,
  assetImportProcessSaga,
  importLogslistSaga,
  bulkDelete,
  assetImportedJobDelete,
  exportLoglistSaga,
  assetExportJobDelete
} from '../../api/assetsSaga';
import { listAssets, listExportJobs, listImportJobs } from '../../actions/assets';
import { showToastError, showToastSuccess, showToastLoader, dismissToastLoader } from '../../utils/toasts';

export function* watchList(action) {
  try {
    const response = yield call(listSaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({ type: ASSET_LIST_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchImportLogs(action) {
  try {
    const response = yield call(importLogslistSaga, action.payload);
    if (response.success) {
      yield put({ type: IMPORT_ASSET_LOGS_SUCCESSED, data: response });
    } else {
      yield put({ type: IMPORT_ASSET_LOGS_FAILED, data: null });
    }
  } catch (err) {
    yield put({ type: IMPORT_ASSET_LOGS_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchExportLogs(action){
  try{
    const response = yield call(exportLoglistSaga, action.payload);
    if(response.success){
      yield put({type: EXPORT_ASSET_LOGS_SUCCESSED, data: response});
    }else{
      yield put({type: EXPORT_ASSET_LOGS_FAILED, data: null});
    }
  }catch(err){
    yield put({type: EXPORT_ASSET_LOGS_FAILED, data: err?.response?.data?.data});
  }
}

export function* watchGetSingle(action) {
  try {
    const response = yield call(getSingleSaga, action.id, action.isExpand);
    if (response.success) {
      yield put({ type: ASSET_DETAILS_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_DETAILS_FAILED, data: null });
    }
  } catch (err) {
    yield put({ type: ASSET_DETAILS_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchGetDashboardSingle(action) {
  try {
    const response = yield call(getAssetDashboardSaga, action.id);
    if (response.success) {
      yield put({ type: ASSET_DASHBOARD_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_DASHBOARD_FAILED, data: null });
    }
  } catch (err) {
    yield put({ type: ASSET_DASHBOARD_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchCreate(action) {
  const loaderHandle = showToastLoader('Creating asset...')
  try {
    const response = yield call(createSaga, action.payload);
    if (response.success) {
      showToastSuccess('Asset created', loaderHandle)
      yield put({ type: ASSET_CREATE_SUCCESSED, data: response });
      if (action.callback) action.callback();
    } else {
      showToastError('Asset create failed', loaderHandle)
      yield put({ type: ASSET_CREATE_FAILED, data: null });
      if (action.callback) action.callback();
    }
  } catch (err) {
    showToastError('Asset create failed', loaderHandle)
    yield put({ type: ASSET_CREATE_FAILED, data: err?.response?.data?.data });
    if (action.callback) action.callback();
  }
}

export function* watchEdit(action) {
  const loaderHandle = showToastLoader('Updating asset...')
  try {
    const response = yield call(editSaga, action.payload);
    if (response.success) {
      showToastSuccess('Asset updated', loaderHandle)
      yield put({ type: ASSET_EDIT_SUCCESSED, data: response });
      if (action.callback) action.callback();
    } else {
      showToastError('Asset update failed', loaderHandle)
      yield put({ type: ASSET_EDIT_FAILED, data: null });
      if (action.callback) action.callback();
    }
  } catch (err) {
    showToastError('Asset update failed', loaderHandle)
    yield put({ type: ASSET_EDIT_FAILED, data: err?.response?.data?.data });
    if (action.callback) action.callback();
  }
}

export function* watchDelete(action) {
  const loaderHandle = showToastLoader('Deleting asset...')
  try {
    const response = yield call(deleteSaga, action.payload.id);

    if (response.success) {
      showToastSuccess('Asset deleted', loaderHandle)
      yield put({ type: ASSET_DELETE_SUCCESSED, data: response });
      yield put(
        listAssets(
          action.payload.page,
          action.payload.parameter,
          action.payload.perPage
        )
      );
    } else {
      showToastError(`${response?.data?.message}`, loaderHandle)
      yield put({ type: ASSET_DELETE_FAILED, data: null });
    }
  } catch (err) {
    showToastError(`${err?.response?.data?.data?.message}`, loaderHandle)
    yield put({ type: ASSET_DELETE_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchImport(action) {
  const loaderHandle = showToastLoader('Importing asset file...')
  try {
    const response = yield call(importSaga, action.payload);
    if (response.success) {
      dismissToastLoader(loaderHandle);
      yield put({ type: IMPORT_ASSET_SUCCESSED, data: response });
    } else {
      showToastError('Asset Import file upload failed', loaderHandle)
      yield put({ type: IMPORT_ASSET_FAILED, data: null });
    }
  } catch (err) {
    showToastError('Asset Import file upload failed', loaderHandle)
    yield put({ type: IMPORT_ASSET_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchAssetClassificationList(action) {
  try {
    const response = yield call(listAssetClassificationSaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_CLASSIFICATION_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_CLASSIFICATION_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_CLASSIFICATION_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetConfidentialityList(action) {
  try {
    const response = yield call(listAssetConfidentialitySaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_CONFIDENTIALITY_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_CONFIDENTIALITY_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_CONFIDENTIALITY_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetAvailabilityList(action) {
  try {
    const response = yield call(listAssetAvailabilitySaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_AVAILABILITY_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_AVAILABILITY_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_AVAILABILITY_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetIntegrityList(action) {
  try {
    const response = yield call(listAssetIntegritySaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_INTEGRITY_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_INTEGRITY_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_INTEGRITY_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetOSList(action) {
  try {
    const response = yield call(listAssetOSSaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_OS_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_OS_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_OS_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetTypeByID(action) {
  try {
    const response = yield call(getAssetTypeById, action.id);
    if (response.success) {
      yield put({ type: ASSET_TYPE_BY_ID_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_TYPE_BY_ID_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_TYPE_BY_ID_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetTypesList(action) {
  try {
    const response = yield call(listAssetTypesSaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_TYPES_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_TYPES_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_TYPES_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetCategoriesList(action) {
  try {
    const response = yield call(listAssetCategoriesSaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_CATEGORIES_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_CATEGORIES_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_CATEGORIES_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetEnableFieldsList(action) {
  try {
    const response = yield call(listAssetEnableFieldsSaga, action.payload);
    if (response.success) {
      yield put({ type: ASSET_ENABLE_FIELDS_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_ENABLE_FIELDS_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_ENABLE_FIELDS_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchgetAssetFieldsList(action) {
  try {
    const response = yield call(listGetAssetFieldsSaga, action.field);
    if (response.success) {
      yield put({ type: ASSET_CATEGORY_FIELDS_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_CATEGORY_FIELDS_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_CATEGORY_FIELDS_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchAssetTemplateList(action) {
  try {
    const response = yield call(getAssetTemplates);
    if (response.success) {
      yield put({ type: ASSET_TEMPLATE_LIST_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_TEMPLATE_LIST_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: ASSET_TEMPLATE_LIST_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchCreateTemplate(action) {
  const loaderHandle = showToastLoader('Creating template...')
  try {
    const response = yield call(createTemplateSaga, action.payload);
    if (response.success) {
      showToastSuccess(`${response?.data?.message}`, loaderHandle)
      yield put({ type: ASSET_TEMPLATE_CREATE_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_TEMPLATE_CREATE_FAILED, data: null });
    }
  } catch (err) {
    showToastError(`${err?.response?.data?.data}`, loaderHandle)
    yield put({ type: ASSET_TEMPLATE_CREATE_FAILED, data: err?.response?.data?.data });
  }
}

export function* draftTemplate(action) {
  const loaderHandle = showToastLoader('Creating template...')
  try {
    const response = yield call(assetTemplateDraftSaga, action.payload);
    if (response.success) {
      showToastSuccess(`${response?.data?.result}`, loaderHandle)
      yield put({ type: ASSET_TEMPLATE_DRAFT_SUCCESSED, data: response });
    } else {
      showToastError(`${response?.message?.result}`, loaderHandle)
      yield put({ type: ASSET_TEMPLATE_DRAFT_FAILED, data: null });
    }
  } catch (err) {
    showToastError(`${err?.response?.data?.data}`, loaderHandle)
    yield put({ type: ASSET_TEMPLATE_DRAFT_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchassetImportProcess(action) {
  try {
    const loaderHandle = showToastLoader('Importing template...')
    const response = yield call(assetImportProcessSaga, action.payload);
    if (response.success) {
      showToastSuccess(`Asset imported`, loaderHandle)
      yield put({ type: ASSET_IMPORT_PROCESS_SUCCESSED, data: response });
    } else {
      yield put({ type: ASSET_IMPORT_PROCESS_FAILED, data: null });
    }
  } catch (err) {
    yield put({ type: ASSET_IMPORT_PROCESS_FAILED, data: err?.response?.data?.data });
  }
}

export function* watchBulkDelete(action) {
  const loaderHandle = showToastLoader('Deleting records...')
  try {
    const deleteAssetData = yield call(bulkDelete, action.payload);

    if (deleteAssetData.success === true) {
      showToastSuccess('Records deleted', loaderHandle)
      yield put({ type: ASSET_BULK_DELETE_SUCCESSED, data: deleteAssetData });
      const response = yield put(
        listAssets(
          action.pageinfo.page,
          action.pageinfo.parameter,
          action.pageinfo.perPage
        )
      );
      if (response.success) {
        yield put({ type: ASSET_LIST_SUCCESSED, data: response });
      } else {
        yield put({ type: ASSET_LIST_FAILED, data: null });
      }


    } else {
      showToastError('Records delete failed', loaderHandle)
      yield put({ type: ASSET_BULK_DELETE_FAILED, data: null });
    }
  } catch (err) {
    showToastError('Records delete failed', loaderHandle)
    yield put({
      type: ASSET_BULK_DELETE_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchImportedJobDelete(action) {
  const loaderHandle = showToastLoader('Deleting job...')
  try {
    const deleteAssetImportData = yield call(assetImportedJobDelete, action.payload);

    if (deleteAssetImportData.success === true) {
      showToastSuccess('Imported job deleted', loaderHandle)
      yield put({ type: ASSET_IMPORTED_JOB_DELETE_SUCCESSED, data: deleteAssetImportData });

      const response = yield put(
        listImportJobs(
          action.pageinfo.page,
          action.pageinfo.parameter,
          action.pageinfo.perPage
        )
      );
      if (response.success) {
        yield put({ type: IMPORT_ASSET_LOGS_SUCCESSED, data: response });
      } else {
        yield put({ type: IMPORT_ASSET_LOGS_FAILED, data: null });
      }

    } else {
      showToastError('Impoted job delete failed', loaderHandle)
      yield put({ type: ASSET_IMPORTED_JOB_DELETE_FAILED, data: null });
    }
  } catch (err) {
    showToastError('Imported job delete failed', loaderHandle)
    yield put({
      type: ASSET_IMPORTED_JOB_DELETE_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchExportJobDelete(action){
  const loaderHandle = showToastLoader('Deleting job...')
  try {
    const deleteAssetExportData = yield call(assetExportJobDelete, action.payload);
    if (deleteAssetExportData.success === true) {
      showToastSuccess('Exported job deleted', loaderHandle);
      yield put({type: ASSET_EXPORT_JOB_DELETE_SUCCESSED, data: deleteAssetExportData});

      const response = yield put(
        listExportJobs(1,'',20,'',action?.payload?.module)
      );
      if (response.success) {
        yield put({type: EXPORT_ASSET_LOGS_SUCCESSED, data: response});
      } else {
        yield put({type: EXPORT_ASSET_LOGS_FAILED, data: null})
      }
    } else {
      yield put({type: EXPORT_ASSET_LOGS_FAILED, data: null})
    }
  } catch (err) {
     showToastError('Exported job delete failed', loaderHandle)
      yield put({
        type: ASSET_EXPORT_JOB_DELETE_FAILED,
        data: err?.response?.data?.data,
      })
  }
}

// export function* watchExportedJobDeleted
export default function* watcher() {
  yield takeLatest(ASSET_LIST_REQUESTED, watchList);
  yield takeLatest(IMPORT_ASSET_LOGS_REQUESTED, watchImportLogs);
  yield takeLatest(EXPORT_ASSET_LOGS_REQUESTED, watchExportLogs);
  yield takeLatest(ASSET_DELETE_REQUESTED, watchDelete);
  yield takeLatest(ASSET_EDIT_REQUESTED, watchEdit);
  yield takeLatest(ASSET_CREATE_REQUESTED, watchCreate);
  yield takeLatest(ASSET_DETAILS_REQUESTED, watchGetSingle);
  yield takeLatest(IMPORT_ASSET_REQUESTED, watchImport);
  yield takeLatest(
    ASSET_CLASSIFICATION_LIST_REQUESTED,
    watchAssetClassificationList
  );
  yield takeLatest(
    ASSET_CONFIDENTIALITY_LIST_REQUESTED,
    watchAssetConfidentialityList
  );
  yield takeLatest(
    ASSET_AVAILABILITY_LIST_REQUESTED,
    watchAssetAvailabilityList
  );
  yield takeLatest(
    ASSET_INTEGRITY_LIST_REQUESTED,
    watchAssetIntegrityList
  );
  yield takeLatest(ASSET_OS_LIST_REQUESTED, watchAssetOSList);
  yield takeLatest(ASSET_TYPE_BY_ID_REQUESTED, watchAssetTypeByID);
  yield takeLatest(ASSET_DASHBOARD_REQUESTED, watchGetDashboardSingle);
  yield takeLatest(ASSET_CATEGORIES_LIST_REQUESTED, watchAssetCategoriesList);
  yield takeLatest(ASSET_TYPES_LIST_REQUESTED, watchAssetTypesList);
  yield takeLatest(
    ASSET_ENABLE_FIELDS_LIST_REQUESTED,
    watchAssetEnableFieldsList
  );
  yield takeLatest(
    ASSET_CATEGORY_FIELDS_REQUESTED,
    watchgetAssetFieldsList
  );
  yield takeLatest(
    ASSET_TEMPLATE_LIST_REQUESTED,
    watchAssetTemplateList
  );
  yield takeLatest(ASSET_TEMPLATE_CREATE_REQUESTED, watchCreateTemplate);
  yield takeLatest(ASSET_TEMPLATE_DRAFT_REQUESTED, draftTemplate);
  yield takeLatest(ASSET_IMPORT_PROCESS_REQUESTED, watchassetImportProcess);
  yield takeLatest(ASSET_BULK_DELETE_REQUESTED, watchBulkDelete);
  yield takeLatest(ASSET_IMPORTED_JOB_DELETE_REQUESTED, watchImportedJobDelete);
  yield takeLatest(ASSET_EXPORT_JOB_DELETE_REQUESTED, watchExportJobDelete);
}
